import { get } from "lodash";
import { useGetProfileQuery } from "~/schemas/generated/graphql";

/** Роль текущего пользователя из профиля — данные, а не проверка доступа */
export const useUserRole = (): string => {
  const getProfile = useGetProfileQuery({});
  return get(getProfile, "data.UserGetter.getProfile.role", "");
};
